export default {
  title: 'Minimumsbeløb for betaling: Betalinger kan ikke ligge mellem {{rangeStart}} og {{rangeEnd}}',
  description: 'Undtagelse: Når du har en gratis vare, kan du gennemføre købet med et samlet beløb på {{amount}}.',
};
